export { EDITOR_TYPE, TimeEditor } from "./timeEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/timeEditor/index.mjs
// module id = 452
// module chunks = 1